import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, MapPin, Scale, HelpCircle } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      style={{
        background: '#0d0d11',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        color: '#9e9eb0',
        padding: '48px 24px 32px',
        marginTop: '60px',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Top Section */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '32px',
            marginBottom: '40px',
          }}
        >
          {/* Brand & Mission */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
              <div
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #7c3aed 0%, #3b82f6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: 900,
                  fontSize: '14px',
                }}
              >
                P
              </div>
              <span style={{ fontSize: '18px', fontWeight: 800, color: '#ffffff', letterSpacing: '-0.02em' }}>
                KHELDROP
              </span>
            </div>
            <p style={{ fontSize: '13px', lineHeight: 1.6, color: '#828292', margin: '0 0 16px' }}>
              Decentralized peer-to-peer sports matchmaking & real-time pickup game coordination. Zero-cost, recreational athletic network.
            </p>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                borderRadius: '999px',
                background: 'rgba(16, 185, 129, 0.1)',
                border: '1px solid rgba(16, 185, 129, 0.25)',
                color: '#34d399',
                fontSize: '11.5px',
                fontWeight: 600,
              }}
            >
              <ShieldCheck size={14} /> DPDP Act 2023 & IT Rules Compliant
            </div>
          </div>

          {/* Legal & Compliance Links */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#ffffff', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '16px' }}>
              Legal & Trust
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <li>
                <Link to="/terms" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Privacy Notice
                </Link>
              </li>
              <li>
                <Link to="/community-guidelines" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Community Guidelines
                </Link>
              </li>
              <li>
                <Link to="/safety" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Safety Guidelines
                </Link>
              </li>
              <li>
                <Link to="/age-policy" style={{ color: '#ec4899', textDecoration: 'none', fontSize: '13.5px', fontWeight: 600 }}>
                  Age Policy (18+)
                </Link>
              </li>
              <li>
                <Link to="/guide" style={{ color: '#a78bfa', textDecoration: 'none', fontSize: '13.5px', fontWeight: 600 }}>
                  How to Host & Join (Guide)
                </Link>
              </li>
            </ul>
          </div>

          {/* Privacy & Rights */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#ffffff', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '16px' }}>
              Privacy & Rights
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <li>
                <Link to="/location-privacy" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Location Privacy Notice
                </Link>
              </li>
              <li>
                <Link to="/grievance" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Grievance Redressal
                </Link>
              </li>
              <li>
                <Link to="/copyright" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Copyright & IP Policy
                </Link>
              </li>
              <li>
                <Link to="/settings" style={{ color: '#b2b2c4', textDecoration: 'none', fontSize: '13.5px' }}>
                  Privacy Center & Data Rights
                </Link>
              </li>
            </ul>
          </div>

          {/* Statutory Grievance & Contact */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#ffffff', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '16px' }}>
              Grievance Officer
            </div>
            <p style={{ fontSize: '12.5px', color: '#b2b2c4', margin: '0 0 8px', lineHeight: 1.5 }}>
              <strong>Ashutosh Yadav</strong> (DPO & Grievance Officer)<br />
              KhelDrop Technologies Pvt. Ltd.<br />
              NCR Delhi – 122002, India
            </p>
            <p style={{ fontSize: '12.5px', color: '#b2b2c4', margin: '0 0 12px' }}>
              Complaints: <a href="mailto:grievance@kheldrop.app" style={{ color: '#a78bfa', textDecoration: 'none', fontWeight: 600 }}>grievance@kheldrop.app</a><br />
              Support: <a href="mailto:support@kheldrop.app" style={{ color: '#a78bfa', textDecoration: 'none', fontWeight: 600 }}>support@kheldrop.app</a>
            </p>
            <div style={{ fontSize: '11px', color: '#71717a' }}>
              Statutory response: 24h acknowledgement | 7-day resolution
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: '1px', background: 'rgba(255, 255, 255, 0.08)', marginBottom: '24px' }} />

        {/* Bottom Bar */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
            fontSize: '12px',
            color: '#71717a',
          }}
        >
          <div>
            © {new Date().getFullYear()} KhelDrop Technologies Private Limited. All rights reserved.
          </div>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <Link to="/terms" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Terms</Link>
            <Link to="/privacy" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/community-guidelines" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Community</Link>
            <Link to="/safety" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Safety</Link>
            <Link to="/location-privacy" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Location</Link>
            <Link to="/grievance" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Grievance</Link>
            <Link to="/copyright" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Copyright</Link>
            <a href="mailto:support@kheldrop.app" style={{ color: '#8f8fa3', textDecoration: 'none' }}>Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
